<template>
  <div style="width:100%;height:100%;display:flex;flex-direction:row;align-items:center; justify-content:center">
    <notes :title="'Need Review'" :modalClose="closeReview" :submit="needReview" v-if="is_note_open" />
    <div class="k3l-approval-container">
      <!-- <Loading v-if="$store.state.globalLoading" /> -->
      <div class="k3l-approval-dialog">
        <div class="k3l-approval-content">
          <div class="k3l-approval-body">
            <!-- Table Detail Penilaian -->
            <Table-Detail />
            <!-- Kategory Penilaian -->
            <div
              style="padding-bottom:1%;padding-right:1%;border-right:1px solid gray;border-bottom:1px solid gray; margin-bottom:16px">
              <div class="flex-row" style="background-color:#CCFFB3">
                <div class="text-sm text-bold text-center border column20" style="padding:5px">
                  TINGKAT RESIKO PEKERJAAN
                </div>
                <div class="text-sm text-bold text-center border column20" style="padding:5px">
                  NILAI
                </div>
                <div class="text-sm text-bold text-center border column60 col-nohover" style="padding:5px">
                  KETERANGAN
                </div>
              </div>
              <div class="flex-row" v-for="(item, index) in tableDesc" :key="index">
                <div :class="`${item.styling1} border flex-center`"
                  :style="`height: auto; background-color: ${item.color}`">
                  {{ item.desc1 }}
                </div>
                <div :class="`${item.styling2} border`" style="height: auto" v-html="item.desc2"></div>
                <div :class="`${item.styling3} border`" style="height: auto" v-html="item.desc3"></div>
              </div>
            </div>
            <!-- Table Evaluasi -->
            <div class="flex-row " style="position:relative">
              <div class="column25 flex-row" style="position: absolute;top:-15px">
                <div class="text-ssm mr5">Jenis Penilaian :</div>
                <div>
                  <div class="flex-row" style="height:0.75rem; margin-bottom:2px">
                    <div class="border-check text-ssm flex-center mr5">
                      &#128504;
                    </div>
                    <div class="text-ssm">
                      PQ1 - Dokumen
                    </div>
                  </div>
                  <div class="flex-row" style="height:0.75rem">
                    <div class="border-check text-ssm flex-center mr5">
                      -
                    </div>
                    <div class="text-ssm">
                      PQ2 - Audit Lapangan
                    </div>
                  </div>
                </div>
              </div>
              <div class="column25" style="background-color: transparent">
                &nbsp;
              </div>
              <div class="column25 border-gray text-center text-bold" style="background-color: #66FF66">
                NAMA
              </div>
              <div class="column25 border-gray text-center text-bold" style="background-color: #66FF66">
                POSISI
              </div>
              <div class="column25 border-gray text-center text-bold" style="background-color: #66FF66">
                TANDATANGAN
              </div>
            </div>
            <div class="flex-row">
              <div class="column25 flex-row border-gray flex-center">
                Dievaluasi Oleh
              </div>
              <div class="column25 border-gray"></div>
              <div class="column25 border-gray"></div>
              <div class="column25 border-gray"></div>
            </div>
            <div class="flex-row">
              <div class="column25 flex-row border-gray flex-center">
                Ditinjau ulang Oleh
              </div>
              <div class="column25 border-gray"></div>
              <div class="column25 border-gray"></div>
              <div class="column25 border-gray"></div>
            </div>
            <div class="flex-row">
              <div class="column25 flex-row border-gray flex-center">
                Diketahui Oleh
              </div>
              <div class="column25 text-center border-gray">
                SIPM Specialist
              </div>
              <div class="column25 text-center border-gray">
                SIPM Specialist
              </div>
              <div class="column25 text-center border-gray">Approved</div>
            </div>
            <div class="mt10 text-sm">
              Hasil penilaian prakualifikasi K3L ini berlaku di PT Berau Coal
              dan tidak valid jika hasil penilaian baru telah keluar atau bila
              terjadi kecelakaan fatality atau Lost Time Insident (LTI) di
              kontraktor saat bekerja untuk PT Berau Coal.
            </div>
            <!-- Footer / Button Place -->
            <div style="position:relative; width:100%; height:17%">
              <div class="flex-row" style="position:absolute;width:100%;border-top:1px solid gray;bottom: 10px;"
                v-if="this.$store.state.role_id == 4">
                <div style="cursor:pointer;margin-right:10px" @click="validation()">
                  <div style="color:rgb(204, 51, 51)">Validasi</div>
                </div>
                <!-- <div style="cursor:pointer;margin-right:10px">
                  <div style="color:rgb(204, 51, 51)" @click="openReview()">
                    Need Review
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  components: {
    TableDetail: () =>
      import('@/components/molecules/tableDetailPenilaian.vue'),
    Notes: () => import('@/components/modal/k3l/notes.vue'),
  },
  data() {
    return {
      tableDesc: [
        {
          color: '#FF0000',
          desc1: 'HIGH A',
          desc2: '>80 - 100',
          desc3:
            'Pengadaan Jasa / Barang dengan kategori pekerjaan di area Operasi Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen IUJP/SIUP, Rencana K3L & Pekerjaan kritis >4 aktifitas.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
        {
          color: '#FFC000',
          desc1: 'MEDIUM B1',
          desc2: '>50 - &#8804;80',
          desc3:
            'Pengadaan Jasa / Barang dengan kategori pekerjaan di area Operasi Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen IUJP/SIUP, Rencana K3L & Pekerjaan kritis 2&#8805; - &#8804;4 aktifitas.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
        {
          color: '#FFFF00',
          desc1: 'MEDIUM - B2',
          desc2: '>35 - &#8804;50',
          desc3:
            'Pengadaan Jasa / Barang dengan kategori pekerjaan di area Operasi Non Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen SIUP & Pekerjaan kritis &#8804;2 aktifitas.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
        {
          color: '#00B050',
          desc1: 'LOW - C1',
          desc2: '>20 - &#8804;35',
          desc3:
            'Pengadaan Jasa dengan kategori pekerjaan di area Operasi Non Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen SIUP.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
        {
          color: '#92D050',
          desc1: 'LOW - C2',
          desc2: '0 - &#8804;20',
          desc3:
            'Pengadaan Barang dengan kategori pekerjaan di area Operasi Non Tambang, membutuhkan sertifikasi keahlian umum hingga khusus, membutuhkan dokumen SIUP.',
          styling1: 'text-sm text-bold column20',
          styling2: 'text-sm column20',
          styling3: 'text-sm column60 col-nohover',
        },
      ],
      is_note_open: false,
    }
  },
  methods: {
    validation() {
      const url = `${process.env.VUE_APP_LANDINGPAGE_URL}k3l-assessor-landingpage/${this.$route.params.id}/${this.$store.state.userid}`
      window.open(url, '_blank')
    },
    openReview() {
      this.is_note_open = true
    },
    closeReview() {
      this.is_note_open = false
    },
    async needReview(catatan) {
      const id = this.$route.params.id
      const user_id = this.$store.state.userid
      const url = `${api}/api/v1/request/reviewoc-k3l/${id}`

      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      try {
        const { data: response } = await axios({
          method: 'POST',
          url,
          data: {
            user_id,
            note: catatan,
          },
        })

        if (response && response.status == 'success') {
          this.is_note_open = false
          await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          await this.$store.commit('SET_NOTIF', response.message)
          this.$router.push({ path: '/approval' })
        }
      } catch (error) {
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        await this.$store.commit('SET_NOTIF', error.response.data.message)
      }
    },
  },
}
</script>
